import 'i18n'

import Dialer from 'modules/Dialer'

if (!window.dialer) {
  window.dialer = new Dialer()
}
